import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useIsAuthenticated,
  useMsal,
} from "@azure/msal-react";
import { useEffect } from "react";
import LoginPage from "../../pages/LoginPage";
import { InteractionStatus } from "@azure/msal-browser";
import LoadingPage from "../../pages/LoadingPage";
import AccessDeniedPage from "../../pages/403";

const ALLOWED_EMAIL_DOMAIN = "@grundfos.com";

interface Props {
  children: React.ReactNode;
}

export default function Root({ children }: Props) {
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (accounts.length > 0) {
      instance.setActiveAccount(accounts[0]);
    }
  }, [inProgress, isAuthenticated, accounts, instance]);

  if (inProgress === InteractionStatus.Startup) {
    return <LoadingPage />;
  }

  const email = (
    (accounts[0]?.idTokenClaims?.signInName as string | undefined) ?? ""
  ).toLowerCase();
  const isAllowedDomain = email.endsWith(ALLOWED_EMAIL_DOMAIN);

  return (
    <>
      <AuthenticatedTemplate>
        {isAllowedDomain ? children : <AccessDeniedPage />}
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <LoginPage />
      </UnauthenticatedTemplate>
    </>
  );
}
